import { SocialType, Number } from 'sections/Company/ContactUs/types';

export const Social: SocialType = {
  facebook: 'https://www.facebook.com/DigitalFreightAlliance_DPWorld',
  twitter: 'https://twitter.com/D_F_Alliance',
  linkedin: 'https://www.linkedin.com/company/digital-freight-alliance',
  youtube: 'https://www.youtube.com/c/SeaRatesOfficial/videos',
  instagram: 'https://www.instagram.com/searatesllc/',
};

export const numbersList: Number[] = [
  { code: 'es', phone: '+34 91 215 8127' },
  { code: 'cn', phone: '+86 400 819 1292' },
  { code: 'do', phone: '+1 829 954 0405' },
  { code: 'ph', phone: '+63 28 540 1745' },
  { code: 'us', phone: '+1 646 722 4762' },
  { code: 'gb', phone: '+44 207 660 8020' },
  { code: 'ca', phone: '+1 833 420 0983' },
  { code: 'ua', phone: '+380 89 324 31 05' },
];